import React from 'react'
import MenuItemsList from './MenuItemsList'
import SocialMediaLinkList from '../General/SocialMediaLinkList'
import MenuItemLanguageChooser from './MenuItemLanguageChooser'
import ServicePagesMenu from '../SiteFooter/ServicePagesMenu'


const SiteNavigationMobile =({menuItemsData, servicePagesMenuData, programOverviewSubmenus, translation, attributes, socialmediaData, onToggleNavigation, programOverviewUrl }) => (
    <nav id="main-navigation" className="site-navigation site-navigation-mobile" role="navigation" aria-label="Menü">
        <ul className="menu">
            {translation.languages && <MenuItemLanguageChooser 
                translation={translation}
            />}
            <MenuItemsList
                menuItemsData={menuItemsData}
                programOverviewSubmenus={programOverviewSubmenus}
                translation={translation}
                onToggleNavigation={onToggleNavigation}
                isMobile={true}
                attributes={attributes}
                onMenuItemMouseEnter={null}
                onMenuItemMouseLeave={null}
                programOverviewUrl={programOverviewUrl}
            />
            
            <li className="menu-item menu-item-impressum">
                <ServicePagesMenu 
                    bottomMenuData={servicePagesMenuData}
                />
            </li>
    
            <li className="menu-item menu-item-socialmedia">
                <SocialMediaLinkList 
                    socialmediaData={socialmediaData} 
                />
            </li>
        </ul>
    </nav>
)


export default SiteNavigationMobile